// @module NVT.MyEvent.MyCoolModule
define('NVT.MyRegisterColleague.MyPendingReview.View'
,	[
		'nvt_pending_review.tpl'
	
	,	'NVT.MyRegisterColleague.MyRegisterColleague.SS2Model'
	
	,	'Backbone'

	, 	'GlobalViews.Message.View'

	,	'GlobalViews.Confirmation.View'

	,	'NVT.MyRegisterColleague.MyPendingReview.View'

	,	'Profile.Model'

	,	'Utils'

    ]
, function (
		nvt_pending_review_tpl
	
	,	MyRegisterColleagueSS2Model
	
	,	Backbone

	,   MessageView

	, 	GlobalViewsConfirmationView

	,	MyPendingReviewView

	,	ProfileModel

	,	Utils

)
{
    'use strict';
	var alreadyProcessDone = true;

	// @class NVT.MyRegisterColleague.MyPendingReview.View @extends Backbone.View
	return Backbone.View.extend({

		template: nvt_pending_review_tpl

	,	initialize: function (options) {

			this.options = options;
			this.container = options.container;
			this.layout = this.container.getComponent('Layout');
			this.pdp = this.container.getComponent('PDP');

			this.model = new MyRegisterColleagueSS2Model();
			var self = this;
			var profile = ProfileModel.getInstance();
			var is_loged_in = profile.get('isLoggedIn') === 'T';

			if(is_loged_in)
			{
				var skuname = self.pdp.getItemInfo() ?	self.pdp.getItemInfo().item.internalid : '';
				this.model.fetch({async: false,data: {
				   'paramid': skuname,
				   'getmethod':'getlistStatusPendingReview'
			   	}}).done(function(result) {
					if(result)
					{
						self.data = result;	
						var isshowmodel = !!result.find(item =>item.praddtocart === true);

						if(isshowmodel && alreadyProcessDone)
						{
							alreadyProcessDone = false;
							setTimeout(function() {
								self.ispendingreviewshowng();
							}, 300);
						}
					}			 
				   self.render();
				});
			}
		}

	,	events: {
			'click button[data-action="data-action-praddtocart"]': 'PendingReviewAddToCart'
		}

	,	bindings: {

		}

	,	ispendingreviewshowng:function()
		{
			var self = this;
			if (this.layout) {
				var modalMessage = new MyPendingReviewView({ container: this.container});
					modalMessage.modalClass ='modal-lg';
					modalMessage.title = this.pdp.getItemInfo().item.displayname;
				this.options.container.layout.showInModal(modalMessage);
				$.fn.modal.prototype.constructor.Constructor.DEFAULTS.backdrop = 'static';
				$.fn.modal.prototype.constructor.Constructor.DEFAULTS.keyboard =  false;
				return false;
			}		
		}

	,	PendingReviewAddToCart : function(e)
		{
			var self = this;		
			var getcurrentvalue = e.currentTarget.value		
			if(getcurrentvalue)
			{
				var getCurrentIndexValue = self.data.filter(function(prdata) {
					return prdata.internalid == getcurrentvalue && prdata.praddtocart == true
				});

				if(getCurrentIndexValue && getCurrentIndexValue.length > 0)
				{
					var getcurrentLine = getCurrentIndexValue[0];
					var cart = self.options.container.getComponent('Cart');
					var lines = cart.getLines();
					var indexed = true;
					lines.then(function(lines,) {
						for (i=0; i < lines.length; i++) {
							var getitemid = lines[i].item.internalid;
							var getname = lines[i].options !=0 ? lines[i].options.filter(val => val.cartOptionId =='custcol_event_register_name')[0].value.internalid : '';
							var getemail = lines[i].options !=0 ? lines[i].options.filter(val => val.cartOptionId =='custcol_nus_ems_patemail')[0] : '';
								getemail = getemail ? getemail.value.internalid : '';
							if(getitemid == getcurrentLine.itemid && getemail ==  getcurrentLine.email)
							{
								indexed = false;
							}					
						}
					}).then(function() {
							if(indexed)
							{
								self.addTicketEvent(getCurrentIndexValue[0]);
							}
							else{
								var param = getCurrentIndexValue[0];
								const getlay= self.options.container.layout;		
								const global_view_message = new MessageView({
									message: Utils.translate('Selected contact name already exits in cart, please select different contact list'),
									type: 'error',
									closable: true
								});					
		
								getlay.$('[data-type="alert-placeholder-message-'+param.internalid+'"]').html(global_view_message.render().$el.html());
								const confirmation_message = getlay.$('[data-type="alert-placeholder-message-'+param.internalid+'"]').css("display","block");
				
								setTimeout(function() {
									confirmation_message.fadeOut(3000);
								}, 35000);
		
								return false;
							}
					});
				}
			}
			
		}

	,	addTicketEvent : function(param)
		{
			var self = this;				
			var cart = self.options.container.getComponent('Cart');
			var cardEventAdded =	cart.addLines({
					lines:  [
						{
							quantity: 1,
							options:[
								{	cartOptionId:"custcol_nus_ref_participantid",value:{internalid: param.internalid+""}},
								{   cartOptionId:"custcol_event_register_name",value:{internalid: param.name }},
								{   cartOptionId:"custcol_nus_ems_patemail",value:{internalid: param.email }},
							],
							item: {
								internalid: param.itemid,
							},
							price:"12",						
						},							
					]
			}).then(function() {
				window.location.href = '/cart';
				// const getlay= self.options.container.layout;		
				// const global_view_message = new MessageView({
				// 	message: Utils.translate('Event added in Cart'),
				// 	type: 'success',
				// 	closable: true
				// });					

				// getlay.$('[data-type="alert-placeholder-message-'+param.internalid+'"]').html(global_view_message.render().$el.html());
				// const confirmation_message = getlay.$('[data-type="alert-placeholder-message-'+param.internalid+'"]').css("display","block");

				// setTimeout(function() {
				// 	confirmation_message.fadeOut(3000);
				// }, 35000);

			});
		}

		//@method getContext @return NVT.MyRegisterColleague.MyPendingReview.View.Context
	,	getContext: function getContext()
		{
			//@class NVT.MyRegisterColleague.MyPendingReview.View.Context
			var self = this;
			
			return {
				listpendingreview : self.data || '',
				itemname : self.pdp.getItemInfo() ? self.pdp.getItemInfo().item.displayname : ''
			};
		}
	});
});
